module.exports = __webpack_public_path__ + "static/img/3177_phase_function_Paper_PointsHejduk_Prediction.ba7984b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3177_phase_function_Paper_PointsHejduk_Prediction.png
// module id = l+wY
// module chunks = 0